<template>
    <form @submit.prevent="submit" id="gateway_form">
        <div class="container p-3 pt-5 my-4 border in-border-header">
            <kt-form-section is_first>
                <div class="section-header">
                    {{ $t('label.shop_data') }}
                </div>
                <kt-row>
                    <kt-col lg="6" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="farsi_name">
                                {{ $t('label.farsi_name') }}
                            </kt-form-label>
                            <kt-form-control
                                    id="farsi_name"
                                    name="farsi_name"
                                    v-model="form_data.farsi_name"
                            >
                            </kt-form-control>
                        </kt-form-group>

                    </kt-col>
                    <kt-col lg="6" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="english_name">
                                {{ $t('label.english_name') }}
                            </kt-form-label>
                            <kt-form-control
                                    id="english_name"
                                    name="english_name"
                                    v-model="form_data.english_name"
                                    dir="ltr"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                </kt-row>
                <kt-row>
                    <div class="col-12">
                        <kt-form-group>
                            <kt-form-label for="subcategory_code">
                                {{ $t('label.subcategory_code') }}
                            </kt-form-label>
                            <select
                                    id="subcategory_code"
                                    name="subcategory_code"
                                    v-model="form_data.subcategory_code"
                                    class="form-control kt-selectpicker"
                            >
                                <option
                                        v-bind:key="subcategory.key"
                                        v-for="subcategory in subcategories"

                                        :value="subcategory.key"
                                >
                                    {{ subcategory.value }}
                                </option>
                            </select>
                        </kt-form-group>
                    </div>
                </kt-row>
                <kt-col lg="12" md="12" xs="12">
                    <kt-row>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="province_code">
                                    {{ $t('label.province') }}
                                </kt-form-label>
                                <select
                                    id="province_code"
                                    name="province_code"
                                    v-model="form_data.province_code"
                                    class="form-control kt-selectpicker"
                                >
                                    <option
                                        v-bind:key="province.id"
                                        v-for="province in provinceCodes"
                                        :selected="form_data.province_code == province.province_code"
                                        :value="province.province_code"
                                    >
                                        <span>{{ province.name }}</span>
                                    </option>
                                </select>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="city_code">
                                    {{ $t('label.city') }}
                                </kt-form-label>
                                <select
                                    id="city_code"
                                    name="city_code"
                                    v-model="form_data.city_code"
                                    class="form-control"
                                >
                                    <option
                                        v-bind:key="city.city_code"
                                        v-for="city in getProvinceCities"
                                        :selected="form_data.city_code == city.city_code"
                                        :value="city.city_code"
                                    >
                                        <span>{{ city.name }}</span>
                                    </option>
                                </select>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                </kt-col>

                <kt-row>
                    <kt-col lg="6" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="address">
                                {{ $t('label.address') }}
                            </kt-form-label>
                            <select
                                    v-if="addresses"
                                    id="address"
                                    name="address"
                                    v-model="form_data.address"
                                    class="form-control kt-selectpicker"
                            >
                                <option
                                        v-bind:key="address.id"
                                        v-for="address in addresses"

                                        :value="address.id"
                                >
                                    {{ address.address }}
                                </option>
                            </select>
                            <div class="my-4">
                                <small class="py-2" style="width: 100%; word-wrap: break-word; color: red">
                                    آدرس (کد پستی) انتخابی همان کد پستی باشد که در سامانه مالیات معرفی کرده اید
                                </small>
                            </div>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="6" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="site_address">
                                {{ $t('label.site_address') }}
                            </kt-form-label>
                            <kt-form-control
                                    dir="ltr"
                                    id="site_address"
                                    name="site_address"
                                    placeholder="https://mysite.ir/"
                                    v-model="form_data.site_address">
                            </kt-form-control>
                            <div class="my-2">
                                <small class="py-2" style="width: 100%; word-wrap: break-word; color: red"> مشخصات صاحب امتیاز نماد اعتماد باید با
                                    مشخصات پذیرنده یکسان باشد
                                </small>
                            </div>
                        </kt-form-group>
                    </kt-col>
                </kt-row>
                <kt-row>
                    <kt-col lg="4" md="4" xs="12">
                        <kt-form-group>
                            <kt-form-label for="sheba_number">
                                {{ $t('label.sheba_number') }}
                            </kt-form-label>
                            <select
                                    id="sheba_number"
                                    name="sheba_number"
                                    v-model="form_data.sheba"
                                    class="form-control kt-selectpicker"
                            >
                                <option
                                        v-bind:key="sheba_number.id"
                                        v-for="sheba_number in sheba_numbers"
                                        :value="sheba_number.id"
                                >
                                    {{ sheba_number.number }}
                                </option>
                            </select>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="4" xs="12">
                        <kt-form-group>
                            <kt-form-label for="telephone">
                                {{ $t('label.telephone') }}
                            </kt-form-label>
                            <kt-form-control
                                    dir="ltr"
                                    id="telephone"
                                    name="telephone"
                                    v-model="form_data.telephone"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="4" xs="12">
                        <kt-form-group>
                            <kt-form-label for="tax_payer_code">
                                {{ $t('label.tax_payer_code') }}
                            </kt-form-label>
                            <kt-form-control
                                    dir="ltr"
                                    id="tax_payer_code"
                                    name="tax_payer_code"
                                    v-model="form_data.tax_payer_code"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                </kt-row>
                <kt-row v-if="current_user.user_type != user_types.LEGAL" lg="12" md="12" xs="12">
                    <kt-col lg="4" md="4" xs="12">
                        <kt-form-group>
                            <kt-form-label for="birth_crtfct_number">
                                {{ $t('label.birth_crtfct_number') }}
                            </kt-form-label>
                            <kt-form-control
                                    id="birth_crtfct_number"
                                    name="birth_crtfct_number"
                                    v-model="form_data.birth_crtfct_number"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="4" xs="12">
                        <kt-form-group>
                            <kt-form-label for="telephone">
                                {{ $t('label.phone') }}
                            </kt-form-label>
                            <kt-form-control
                                    dir="ltr"
                                    id="phone_number"
                                    name="phone_number"
                                    v-model="form_data.phone_number"
                            >
                            </kt-form-control>
                            <div class="my-2">
                                <small class="py-2" style="width: 100%; word-wrap: break-word; color: red">شماره موبایل باید به
                                    اسم پذیرنده باشد </small>
                            </div>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="4" xs="12">
                    <div class="container p-3 pt-5 my-4 border in-border-header" >
                        <kt-form-section is_first>
                            <div class="section-header" style="right: -5px;">
                                <kt-form-group class="mb-0">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="has_limit2" name="has_limit"
                                               v-model="form_data.abroad_ips_only_by_user">
                                        <label class="custom-control-label" for="has_limit2">{{ $t('label.abroad_ips_only_by_user') }}</label>
                                    </div>
                                </kt-form-group>
                            </div>

                            <transition name="fade">
                                <kt-form-group v-if="form_data.abroad_ips_only_by_user">
                                    <kt-form-label>
                                        {{ $t('label.limit_amount') }}
                                    </kt-form-label>
                                    <div class="kt-input-icon kt-input-icon--right">
                    <span class="kt-input-icon__icon kt-input-icon__icon--right">
                        <span>{{ $t('label.rial') }}</span>
                    </span>
                                        <kt-form-control
                                                type="text"
                                                dir="ltr"
                                                id="limit_amount"
                                                name="limit_amount"
                                                v-model="form_data.limit_amount_by_user"
                                        >
                                        </kt-form-control>
                                    </div>
                                </kt-form-group>
                            </transition>

                        </kt-form-section>
                    </div>
                    </kt-col>

                </kt-row>
                <kt-row v-else lg="12" md="12" xs="12">
                    <kt-col lg="6" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="telephone">
                                {{ $t('label.phone') }}
                            </kt-form-label>
                            <kt-form-control
                                    dir="ltr"
                                    id="phone_number"
                                    name="phone_number"
                                    v-model="form_data.phone_number"
                            >
                            </kt-form-control>
                            <div class="my-2">
                                <small class="py-2" style="width: 100%; word-wrap: break-word; color: red">شماره موبایل باید به
                                    اسم پذیرنده باشد </small>
                            </div>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="4" xs="12">
                        <div class="container p-3 pt-5 my-4 border in-border-header" >
                            <kt-form-section is_first>
                                <div class="section-header" style="right: -5px;">
                                    <kt-form-group class="mb-0">
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input" id="has_limit2" name="has_limit"
                                                   v-model="form_data.abroad_ips_only_by_user">
                                            <label class="custom-control-label" for="has_limit2">{{ $t('label.abroad_ips_only_by_user') }}</label>
                                        </div>
                                    </kt-form-group>
                                </div>

                                <transition name="fade">
                                    <kt-form-group v-if="form_data.abroad_ips_only_by_user">
                                        <kt-form-label>
                                            {{ $t('label.limit_amount') }}
                                        </kt-form-label>
                                        <div class="kt-input-icon kt-input-icon--right">
                    <span class="kt-input-icon__icon kt-input-icon__icon--right">
                        <span>{{ $t('label.rial') }}</span>
                    </span>
                                            <kt-form-control
                                                    type="text"
                                                    dir="ltr"
                                                    id="limit_amount"
                                                    name="limit_amount"
                                                    v-model="form_data.limit_amount_by_user"
                                            >
                                            </kt-form-control>
                                        </div>
                                    </kt-form-group>
                                </transition>

                            </kt-form-section>
                        </div>
                    </kt-col>


                    <!--                    <kt-col lg="6" md="6" xs="12">-->
<!--                        <kt-form-group>-->
<!--                            <kt-form-label for="abroad_ips_only_by_user">-->
<!--                                {{ $t('label.abroad_ips_only_by_user') }}-->
<!--                            </kt-form-label>-->
<!--                            <select-->
<!--                                    id="abroad_ips_only_by_user"-->
<!--                                    name="abroad_ips_only_by_user"-->
<!--                                    v-model="form_data.abroad_ips_only_by_user"-->
<!--                                    class="form-control kt-selectpicker"-->
<!--                            >-->
<!--                                <option-->
<!--                                        :value="abroad_ips_only_by_users[0].value"-->
<!--                                >-->
<!--                                    {{ abroad_ips_only_by_users[0].name }}-->
<!--                                </option>-->
<!--                                <option-->
<!--                                        :value="abroad_ips_only_by_users[1].value"-->
<!--                                >-->
<!--                                    {{ abroad_ips_only_by_users[1].name }}-->
<!--                                </option>-->
<!--                            </select>-->
<!--                        </kt-form-group>-->
<!--                    </kt-col>-->
                </kt-row>
                <kt-row>
                    <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label>
                                    {{ $t('label.logo') }}
                                </kt-form-label>
                                <kt-form-label for="logo_file" class="d-block btn btn-secondary btn-wide label-file">
                                    <kt-icon type="fa" name="paperclip"></kt-icon>
                                    {{ $t('gateway.btn.click_me') }}
                                </kt-form-label>
                                <input
                                        @change="processLogoFile"
                                        type="file"
                                        class="custom-file-upload"
                                        name="logo"
                                        id="logo_file"
                                        accept="image/png"
                                />
                            </kt-form-group>
                        </kt-col>
                </kt-row>
            </kt-form-section>

            <div class="row align-items-center">
                <div class="col-12 col-md-6 my-2">
                    <div class="custom-control custom-switch">
                        <input type="checkbox"
                               v-model="form_data.settlement_to_wallet"
                               class="custom-control-input"
                               id="settlement_to_wallet"
                               name="settlement_to_wallet"
                        >
                        <label class="custom-control-label" for="settlement_to_wallet"
                               v-text="$t('label.should_settlement_to_wallet')"
                        ></label>
                    </div>
                </div>
            </div>

            <kt-form-action class="mt-4">
                <kt-button
                        class="m-2"
                        size="md"
                        variant="success"
                        type="submit"
                        v-bind:wide="true"
                        id="submit_btn"
                >
                    {{ $t('panel.profile.update.wizard.form.btn.submit') }}
                </kt-button>
            </kt-form-action>
        </div>
    </form>
</template>

<script>
import {subcategories} from '@/constants/subcategories'
import {birthCrtfctSeriesLetters} from '@/constants/birthCrtfctSeriesLetter'
import {province_codes, provinceCities} from '@/constants/cityAndProvinceCodes'
import $ from 'jquery'
import Inputmask from 'inputmask'
import { mapGetters, mapState } from 'vuex'
import { i18n } from '@/plugins/i18n'
import { userTypes } from '@/constants/userTypes';

export default {
    props: {
        submit: {
            default: () => {},
            type: Function
        },
        form_data: {
            default() {
                return {}
            },
            type: Object
        },
    },
    data() {
        return {
            user_types: userTypes,
            subcategories: subcategories,
            etrust_certificate_types: [
                {
                    key: 1,
                    value: this.$t('etrust_certificate_types.one')
                },
                {
                    key: 2,
                    value: this.$t('etrust_certificate_types.two')
                },
                {
                    key: 0,
                    value: this.$t('etrust_certificate_types.other')
                },
            ],
            provinceCodes: province_codes,
        }
    },
    mounted() {
        this.$store.dispatch('shebaNumber/fetch')
                .finally(() => {
                    Object.keys(this.sheba_numbers).map(key => {
                        let number = this.sheba_numbers[key]['number'] == null ? '' : 'IR'+this.sheba_numbers[key]['number'].split('-').join('')
                        this.sheba_numbers[key]['number'] = number
                    })
                })
        this.$store.dispatch('address/fetch').finally(() => {
            this.afterDispatch()
        })
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
            document.getElementById('telephone') && Inputmask('099-99999999').mask(document.getElementById('telephone'))
            document.getElementById('phone_number') && Inputmask('09999999999').mask(document.getElementById('phone_number'))
        },
        processLogoFile(e) {
            this.form_data.logo = event.target.files[0]
            this.validateSize(event.target)
            this.validateFormat(event.target)
        },
        validateSize(file) {
            var FileSize = file.files[0].size / 1024 / 1024; // in MB
            if (FileSize > 1) {
                alert(i18n.t('authenticate.hint.fourth'));
                $(file).val('');
            } else {

            }
        },
        validateFormat(file) {
            let jq_file = $(file);
            let file_name = jq_file.val();
            let extension = file_name.replace(/^.*\./, '');
            if (extension === file_name) {
                extension = '';
            } else {
                extension = extension.toLowerCase();
            }

            switch (extension) {
                case 'png':
                    break;
                default:
                    alert(i18n.t('authenticate.input_format_err'));
                    $(file).val('');
            }
        }
    },
    computed: {
        ...mapGetters('address', [
            'addresses'
        ]),
        ...mapGetters('shebaNumber', [
            'sheba_numbers'
        ]),
        ...mapGetters('user', [
            'current_user'
        ]),
        getProvinceCities() {
            return provinceCities(this.form_data.province_code);
        },
    },
}
</script>

<style scoped>
.label-file {
    border: 1px solid #ccc;
    width: fit-content;
    cursor: pointer;
    min-width: 200px;
}
input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
}
</style>